import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const CDModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  // Add subtopics for each module here
  const subtopicsData = {
    'Module 1': [
      { name: 'Structure and Phases of Compiler Design', path: '/cd-m1-s1' },
      { name: 'Patterns Lexemes-Tokens-Attributes', path: '/cd-m1-s2' },
      { name: 'Specification of Tokens-Extended Regular Expression', path: '/cd-m1-s3' },
      { name: 'Regular expression to Deterministic Finite Automata (Direct method)', path: '/cd-m1-s4' }

      // Add more as needed
    ],
    'Module 2': [
      { name: 'Parse Tree and Elimination of Ambiguity', path: '/cd-m2-s1' },
      { name: 'TOP DOWN PARSER - Backtracking Method', path: '/cd-m2-s2' },
      { name: 'Recursive Descent Parsing', path: '/cd-m2-s3' },
      { name: 'LL1 parser (Predictive Parser)', path: '/cd-m2-s4' },
      { name: 'Shift Reduce Parsers', path: '/cd-m2-s5' },
      { name: 'Operator Precedence Parsing', path: '/cd-m2-s6' },
      { name: 'SLR Parsers', path: '/cd-m2-s7' },
      { name: 'CLR PARSER', path: '/cd-m2-s8' },
      { name: 'LALR Parser', path: '/cd-m2-s9' }

      // Add more as needed
    ],
    'Module 3': [
      { name: 'Syntax directed definition Evaluation Order ', path: '/cd-m3-s1' },
      { name: 'Syntax Directed Translations and implementation of L-Attributed syntax directed translation', path: '/cd-m3-s2' }
      // Add more as needed
    ],
    'Module 4': [
      { name: 'Variants of Syntax trees - Three Address Code ', path: '/cd-m4-s1' },
      { name: 'Backpatching Switch Case Statements', path: '/cd-m4-s2' }
      // Add more as needed
    ],
    'Module 5': [
      { name: 'Loop optimizations & Principal Sources of Optimization ', path: '/cd-m5-s1' },
      { name: 'Introduction to Data Flow Analysis -Basic Blocks - Optimization of Basic Blocks - Peephole Optimization ', path: '/cd-m5-s2' },
      { name: 'The DAG Representation of Basic Blocks -Loops in Flow Graphs - Machine Independent Optimization', path: '/cd-m5-s3' }
      // Add more as needed
    ],
    'Module 6': [
      { name: 'Issues in the design of code generator - Target Machine', path: '/cd-m6-s1' },
      { name: 'Next-Use Information ', path: '/cd-m6-s2' },
      { name: 'Register Allocation and Assignment ', path: '/cd-m6-s3' },
      { name: 'Runtime Organization- Activation Records', path: '/cd-m6-s4' }
      // Add more as needed
    ],
    'Module 7': [
      { name: 'Automatic Parallelization - Optimizations for Cache Locality and Vectorization', path: '/cd-m7-s1' },
      { name: 'Instruction scheduling and software pipelining - static single assignment', path: '/cd-m7-s2' }
      // Add more as needed
    ],
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Compiler Design</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-CDModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>No topics available.</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CDModules;
